import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { getChatMessages } from '../../../services/chats';
import { IChatMessage } from '../../../services/chats/types';

interface IProps {
  chatId: number;
}

export const ThunkGetChatMessages = createAsyncThunk<IChatMessage[], IProps>(
  `${storeResources.CHATS}/getChatMessage`,
  ({ chatId }) => getChatMessages(chatId).then(res => res.data),
);
